import { useEffect } from 'react'
import { Outlet } from '@tanstack/react-router'
import { useQuery } from '@tanstack/react-query'
import { centralApi, ApiError } from '@marque/api/central'
import { Sidebar } from './Sidebar'
import { ResponsiveNavigation } from '@marque/ui'

export function RootLayout() {
    const { data: session, isLoading, isError, error } = useQuery({
        queryKey: ['session'],
        queryFn: centralApi.getMe,
        staleTime: 5 * 60 * 1000,
    })

    useEffect(() => {
        if (isError && error instanceof ApiError && error.status === 401) {
            window.location.href =
                `/bff/signin?returnUrl=${encodeURIComponent(window.location.pathname)}`
        }
    }, [isError, error])

    if (isLoading) {
        return (
            <div className="min-h-screen flex items-center justify-center text-neutral-500">
                Loading…
            </div>
        )
    }

    if (isError || !session) {
        return (
            <div className="min-h-screen flex items-center justify-center text-neutral-500">
                Redirecting to sign in…
            </div>
        )
    }

    return (
        <div className="flex flex-col md:flex-row min-h-dvh bg-neutral-50">
            <ResponsiveNavigation title="Marque Central">
                <Sidebar session={session} />
            </ResponsiveNavigation>
            <main className="flex-1 px-4 py-4 sm:px-6 md:px-8 md:py-8 min-w-0 overflow-x-auto">
                <Outlet />
            </main>
        </div>
    )
}
